import { complaintsReducer } from '@/complaints/complaints-reducer';
import { dashboardReducer } from '@/dashboard/dashboard-reducer';
import { dataReducer } from '@/data/data-reducer';
import { errorReducer } from '@/error-boundaries/error-reducer';
import { mapReducer } from '@/map/map-reducer';
import { userReducer } from '@/user/user-reducer';
import { connectRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import { combineReducers } from 'redux';

/**
 * History object for interacting with HTML5 browser history. This object will
 * be shared between router reducer, router middleware, and router component
 * **Previously BrowserRouter**
 */
export const history = createBrowserHistory();

const appReducer = combineReducers({
  user: userReducer,
  dashboard: dashboardReducer,
  data: dataReducer,
  map: mapReducer,
  error: errorReducer,
  router: connectRouter(history),
  complaints: complaintsReducer,
});

export type AppState = ReturnType<typeof appReducer>;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const rootReducer = (state: AppState, action: any): AppState => {
  switch (action?.type) {
    case 'USER.AUTO_LOGIN_ATTEMPT':
    case 'USER.USER_SIGNOUT':
    case 'USER.SET_CURRENT_CITY_EVERYWHERE': {
      const newState = {
        user: state.user.purgeState(),
        dashboard: undefined,
        data: undefined,
        map: undefined,
        router: { ...state.router },
        error: undefined,
        complaints: undefined,
      };
      return appReducer(newState, action);
    }
    default:
      return appReducer(state, action);
  }
};

export type RootState = ReturnType<typeof rootReducer>;
